import React, { useState } from 'react';

const MenuContent = ({ isOpen, toggleMenu }) => (
    <>
        <div className='navbar navbar-mobile column is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center' role="navigation" aria-label="main navigation">
            <div className="is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center">
                <a href="/">
                    <svg width="51" height="47" viewBox="0 0 51 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.5204 12.2857C29.1845 11.2605 29.8835 16.9226 33.5218 27.7309C38.0755 22.5315 41.4974 8.90707 39.7132 2.4061C39.7798 3.62108 39.6233 5.47184 38.8611 7.35922C36.2314 6.14091 33.3021 5.4552 30.2164 5.4552C18.8455 5.4552 9.62833 14.6724 9.62833 26.0433C9.62833 26.8954 9.68492 27.7309 9.78811 28.5564C7.94733 33.2466 4.90156 38.6724 0.547607 41.1889C18.2297 32.218 14.891 13.4607 22.5204 12.289V12.2857Z" fill="#40B658"/>
                        <path d="M39.0374 0.711795C60.1015 9.9756 41.1345 41.4985 32.9359 43.1728C26.5048 44.4843 25.3498 35.2472 23.5989 29.7182C21.1622 35.3104 15.6732 43.2128 6.89539 42.8033C6.89539 42.8033 6.89539 42.8033 6.89539 42.8067C10.7633 43.3359 14.0887 42.6735 16.7484 41.5983C20.36 44.7273 25.0668 46.6247 30.2197 46.6247C41.5905 46.6247 50.8077 37.4075 50.8077 26.0399C50.8077 24.8682 50.7045 23.7232 50.5181 22.6047C51.9095 14.9121 50.6746 3.96394 39.0441 0.708466L39.0374 0.711795Z" fill="#40B658"/>
                    </svg>
                </a>
            </div>
            <div className="is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center">
                <a onClick={toggleMenu} className={`button ${isOpen ? 'is-hidden' : ''}`}>Menu</a>
            </div>
        </div>

        {/* Sliding Menu */}
        <div className={`menuContainer ${isOpen ? 'open' : ''}`}>
            <div className="menuContent">
                <div className='pr-5 m-0 is-flex is-align-items-center is-justify-content-end'>
                    <div className='pr-1 pt-1'>
                        <a onClick={toggleMenu}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.6718 12.5576C10.1511 12.0369 10.1511 11.1927 10.6718 10.672C11.1925 10.1513 12.0367 10.1513 12.5574 10.672L16.0076 14.1222L19.4543 10.6755C19.975 10.1548 20.8192 10.1548 21.3399 10.6755C21.8606 11.1962 21.8606 12.0404 21.3399 12.5611L17.8932 16.0078L21.3385 19.453C21.8592 19.9737 21.8592 20.8179 21.3385 21.3386C20.8178 21.8593 19.9736 21.8593 19.4529 21.3386L16.0076 17.8934L12.5613 21.3397C12.0406 21.8604 11.1964 21.8604 10.6757 21.3397C10.155 20.819 10.155 19.9748 10.6757 19.4541L14.122 16.0078L10.6718 12.5576Z" fill="#50C4E3"/>
                                <path fillRule="evenodd" clipRule="evenodd" d="M30.6667 16C30.6667 24.1002 24.1002 30.6667 16 30.6667C7.89982 30.6667 1.33333 24.1002 1.33333 16C1.33333 7.89986 7.89982 1.33337 16 1.33337C24.1002 1.33337 30.6667 7.89986 30.6667 16ZM4.0091 16C4.0091 22.6224 9.37761 27.9909 16 27.9909C22.6224 27.9909 27.9909 22.6224 27.9909 16C27.9909 9.37765 22.6224 4.00915 16 4.00915C9.37761 4.00915 4.0091 9.37765 4.0091 16Z" fill="#50C4E3"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div className='pl-5 ml-5 is-flex is-flex-direction-column is-justify-content-center is-align-items-start'>
                    <div className="p-0 m-0">
                        <a href="/" className='big'>Home</a>
                    </div>
                    <div className="p-0 m-0">
                       <a href="/features" className='big'>Features</a>
                    </div>
                    <div className="p-0 m-0">
                       <a href="/pricing" className='big'>Pricing</a>
                    </div>
                    <div className="p-0 m-0">
                       <a href="/how-to" className='big'>How to</a>
                    </div>
                    <div className="p-0 m-0">
                       <a href="/contact" className='big'>Contact</a>
                    </div>
                    <div className="p-0 m-0">
                       <a href="/sign-up" className='big'>Sign up</a>
                    </div>
                </div>
            </div>
        </div>
    </>
);

const HamburgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleMenu = () => {
      setIsOpen(!isOpen);
    };
  
    return <MenuContent isOpen={isOpen} toggleMenu={toggleMenu} />;
  };
  
  export default HamburgerMenu;